import type { ValuesType } from '@fifa-bsm/bo-frontend-shared/utils/types';

export const GuestsVisibility = Object.freeze({
    ALL_GUESTS: 'all-guests',
    LIMITED_BY_ENTITY: 'limited-by-entity',
} as const);

export type IGuestsVisibility = ValuesType<typeof GuestsVisibility>;
